import ApiService from "@/services/ApiService";
import UtilityService from "@/services/UtilityService";
import LoginService from "./LoginService";

class DocumentService {
  openTerm(id) {
    const url = `${ApiService.getApiUrl()}/usr/v2/documents/terms/${id}`;
    this.openDocument(url);
  }

  getBankDocumentData(source) {
    return source &&
      source.data &&
      source.data !== "" &&
      source.data._embedded &&
      source.data._embedded.bankDocumentResourceList
      ? source.data._embedded.bankDocumentResourceList
      : [];
  }

  getStaticContracts() {
    return ApiService.get("/usr/v2/documents/static-contracts?size=50");
  }

  getCurrentFlowStaticContracts() {
    return new Promise((resolve, reject) => {
      const userIsMinor = window.vm.$store.state.user.minor;
      let flow = userIsMinor ? "REG_MIN" : "REG_CONS";

      return ApiService.get("/usr/v2/documents/static-contracts", {
        size: 30,
        flow
      }).then(
        response => {
          resolve(response.staticContracts ? response.staticContracts : []);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  getTerms(level = 2) {
    return ApiService.get(`/usr/v2/documents/terms`, {
      level,
      size: 30
    });
  }

  getMyContracts(id = "me") {
    return ApiService.get(`/usr/v2/documents/contracts/${id}`);
  }

  getDocumentTypes() {
    return ApiService.get("/usr/v2/documents/types");
  }

  getGianos() {
    return ApiService.get("/usr/v2/documents/gianos");
  }

  openContract(contractId, user = "me") {
    this.showDynamicDocument(
      `/usr/v2/documents/contracts/${user}/${contractId}`
    );
  }

  showDynamicDocument(url) {
    //Foo call to refresh token
    ApiService.get("/usr/v2/users/me/context").finally(() => {
      const basePath = ApiService.getApiUrl();
      const accessToken = sessionStorage.getItem("cr_at");
      const separator = url.indexOf("?") > 0 ? "&" : "?";
      const newUrl = `${basePath}${url}${separator}at=${accessToken}`;
      this.openDocument(newUrl);
    });
  }

  getStaticContractUrlFromId(id) {
    return ApiService.getApiUrl() + "/usr/v2/documents/static-contracts/" + id;
  }

  openDocument(url) {
    if (LoginService.getFromApp() === true) {
      UtilityService.sendPostMessage({ action: "openDocument", url });
    } else {
      var docPage = window.open(url, "_blank");
      docPage.opener = null;
    }
  }
}

export default new DocumentService();
